import * as React from "react";
import * as S from "@styled";
import { connect } from "react-redux";
import { IManualTriggerParameter } from "../../model/IProcessData";
import { State } from "../../model/State";
import TriggerInput, { InputMode } from "./TriggerInput";

// Parameter prefix is used for trigger configuration that has everything in element parameters.
// In the case of conditional triggers the parameters are not static so we force the structure of the manual trigger parameters to go under a key.
const parameterPerfix = "parameters";
export const ConditionalTriggerProcessParameters: React.FunctionComponent<ConditionalTriggerProcessParametersProps> = (props: ConditionalTriggerProcessParametersProps) => {
    if (!props.selectedProcessParameters) {
        return null;
    }
    const parametersInStore = Object.keys(props.existingParameters[parameterPerfix]);
    const obsoleteParameters = parametersInStore.filter((p) =>
        !props.selectedProcessParameters?.some((x) => x.name.toLowerCase() === p.toLowerCase()));

    return <>
        {props.selectedProcessParameters.map((parameter) => {
            const parameterFullName = parameterPerfix + "." + parameter.name;
            return <TriggerInput
                key={parameterFullName}
                existingParameters={props.existingParameters}
                name={parameterFullName}
                label={parameter.name}
                description={parameter.description}
                defaultValue={parameter.nonStringifiedDefaultValue}
                inputMode={InputMode.text}
                isSecret={parameter.isSecret}
                showTooltipIcon={parameter.description != null}
                elementId={props.elementId}
            />;
        })}
        {!obsoleteParameters.length ?
            null :
            <div>
                <hr />
                <S.WarningContainer>
                    <div className="alert alert-warning" role="alert">
                        {FRENDS.Localizations.ObsoleteSubprocessParameters}
                    </div>
                </S.WarningContainer>
                {obsoleteParameters.map((parameterName) => {
                    const parameterFullName = parameterPerfix + "." + parameterName;
                    return <TriggerInput
                        key={parameterFullName}
                        existingParameters={props.existingParameters}
                        name={parameterFullName}
                        label={parameterName}
                        description={""}
                        defaultValue={""}
                        inputMode={InputMode.text}
                        isSecret={false}
                        showTooltipIcon={false}
                        elementId={props.elementId}
                    />;
                })}
            </div>
        }
    </>;
};

interface ConditionalTriggerProcessParametersOwnProps {
    elementId: string;
    selectedSubprocessGuid: string;
    existingParameters: any;
}

interface ConditionalTriggerProcessParametersStateProps {
    selectedProcessParameters: IManualTriggerParameter[] | undefined;
}

export type ConditionalTriggerProcessParametersProps = ConditionalTriggerProcessParametersOwnProps & ConditionalTriggerProcessParametersStateProps;
const mapStateToProps = (state: State, ownProps: ConditionalTriggerProcessParametersOwnProps): ConditionalTriggerProcessParametersStateProps => {
    let selectedProcessParameters;
    const foundSubProcess = state.subProcesses.find((subProcess) => subProcess.uniqueIdentifier === ownProps.selectedSubprocessGuid);
    if (foundSubProcess) {
        selectedProcessParameters = foundSubProcess.manualTriggerParameters;
    }
    return {
        selectedProcessParameters: selectedProcessParameters
    };
};

export default connect(mapStateToProps)(ConditionalTriggerProcessParameters);
